<template>
  <div id="content">
    <div id="title">
      <div><span>Mapeos y coberturas</span></div>
      <div style="color: #cccccc;" @click="downloadMapping"><i class="fas fa-cloud-download-alt"></i></div>
    </div>
    <hr style="height: .5px; background-color: #D8DBDB; width: 100%; margin: 0px !important;">
    <div id="content-list">
      <!--show list mapping-->
      <template v-if="lstMapping">
        <ul>
          <template v-for="item in lstMapping.slice().reverse()">
            <li class="item-list">
              <div style="flex-direction: row;display: flex; width: 100%" @click="onClickItemList(item)">
                <div class="item-list-line"/>
                <div class="item-list-date">
                  <p style="font-weight: bold; font-size: 18px">{{ formatDay(new Date(item.fecha)) }}</p>
                  <p style="font-weight: bold; font-size: 12px">{{ formatMonth(new Date(item.fecha)) }} </p>
                </div>
                <div class="item-list-line-gray"/>
                <div class="item-list-name">
                  <p class="item-name">{{ item.nombre }}</p>
                  <p class="item-description">
                    {{ (item.descripcion == null || item.descripcion.length == 0) ? "-" : item.descripcion }}</p>
                </div>
              </div>

              <div class="item-info" @click="showUIDMapping(item.uid)"><i
                  class="fas fa-exclamation-circle"></i></div>
            </li>
          </template>
        </ul>
      </template>
      <!--show empty message-->
      <template v-else>
        <div style="padding: 15px; color:#000000; font-weight: bold;"><p>Sin coberturas</p>
        </div>
      </template>

    </div>
    <div class="text-center">
      <button type="submit" class="button is-primary" @click="onClickNewMapping()">Nueva cobertura</button>
    </div>
  </div>
</template>

<script>

import axios from "axios";
import Vue from "vue";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import {config} from '@/config.json'
import * as LocalStorage from '@/helpers/localstorage'
import * as Utils from '@/helpers/utils'

Vue.use(VueSweetalert2);
export default {
  name: "CoberturaList",
  data() {
    return {
      lstMapping: null,
    }
  },
  methods: {
    getMappingUser: function () {
      const self = this;

      this.$root.$emit('app-show-loading', true);
      axios
          .get(`${config.api.baseURL}/obtenerMapeo/${LocalStorage.getUserId()}/0`)
          .then(function (response) {
            self.lstMapping = Utils.fromJSON(response.data.jsonCompleto);
          })
          .catch(function (err) {
            console.log("CoberturaList: ", err);
          })
          .finally(() => {
            this.$root.$emit('app-show-loading', false);
          });
    },
    onClickItemList(item) {
      this.$root.$emit("navresponsive-show-mapping-abm", {item});
    },
    onClickNewMapping() {
      this.$root.$emit("navresponsive-show-mapping-abm", {undefined});
    },
    formatDay(date) {
      return Utils.formatDate(date, "dd");
    },
    formatMonth(date) {
      return Utils.formatMonthAbrv(date);
    },
    showUIDMapping(uid) {
      this.$swal.fire({
        title: 'Codigo de cobertura',
        icon: 'info',
        html: '' + uid + '',
        showCloseButton: true,
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: '<i class="far fa-copy"></i> Copiar Codigo',
        confirmButtonAriaLabel: 'Copiar Codigo',
        cancelButtonText: 'Cancelar',
        cancelButtonAriaLabel: 'Cerrar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#00a63b',
      }).then((result) => {
        if (result.isConfirmed) navigator.clipboard.writeText(uid);
      })

    },
    downloadMapping() {
      this.$swal
          .fire({
            title: 'Descargar cobertura',
            input: 'text',
            inputLabel: 'Colocar el código de cobertura para descargar',
            showCancelButton: true,
            confirmButtonText: '<i class="fas fa-cloud-download-alt"></i> Descargar cobertura',
            confirmButtonAriaLabel: 'Descargar cobertura',
            cancelButtonText: 'Cancelar ',
            cancelButtonAriaLabel: 'Cerrar',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#00a63b',
            inputValidator: (value) => {
              if (!value) return 'Ingrese el codigo para descargar la cobertura'
            }
          })
          .then((result) => {
            if (result.isConfirmed) this.getMappingFromUID(result.value);
          })
    },
    getMappingFromUID: function (uid) {
      const self = this;
      this.$root.$emit('app-show-loading', true);
      axios
          .get(`${config.api.baseURL}/obtenerMapeoUID/${LocalStorage.getUserId()}/${uid}`)
          .then(function (response) {
            if (response.data.descripcion == 'OK') {
              self.lstMapping.push(Utils.fromJSON(response.data.jsonCobertura));
              return;
            }

            self.$swal.fire({
              icon: 'error',
              title: response.data.descripcion,
              showConfirmButton: false,
              timer: 2000
            })
          })
          .catch((err) => {
            console.log("MappingList: ", err)
          })
          .finally(() => {
            this.$root.$emit('app-show-loading', false);
          });
    }
  },
  created() {
    this.$root.$on('mapping-list-load-data', this.getMappingUser);
  },
  beforeDestroy() {
    this.$root.$off('mapping-list-load-data', this.getMappingUser);
  }

}
</script>

<style scoped>
#content {
  display: flex;
  flex-direction: column;
  height: 95%;
}

#content-list {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: auto;
  height: 85%;
}

#title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-transform: uppercase;
  font-size: 14px;
  color: #4a4a4a;
  font-weight: bold;
  padding: 15px;
}

.item-list {
  display: flex;
  justify-content: space-between;
  border-bottom: .5px solid #cccccc;
  padding: 0 15px 0 0;
  cursor: pointer;
}

.item-list:hover {
  background: #ECF0F1;
}

.item-list-line {
  height: 60px;
  background: #4ba63b;
  width: 10px;
}

.item-list-line-gray {
  height: 60px;
  background: #cccccc !important;
  width: 1px !important;
  padding: 8px 0 8px 0;
}

.item-list-date {
  justify-content: center;
  align-content: center;
  display: flex;
  flex-direction: column;
  text-align: center;
  color: #2c3e50;
  margin: 0 15px 0 15px;
}

.item-list-name {
  text-align: left;
  justify-content: left;
  width: 100%;
  margin: auto auto auto 15px;
}

.item-name {
  color: #2c3e50;
  font-weight: bold;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 13rem;
}

.item-description {
  color: #2c3e50;
  font-size: 0.75rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 13rem;
}

.item-info {
  color: #cccccc;
  font-size: 0.9rem;
  text-align: right;
  margin-top: 15px;
}

.button.is-primary {
  background-color: #106129 !important;
  width: 50%;
  color: #fff;
  padding-right: 5px;
  padding-left: 5px;
  margin-bottom: 10px;
  font-size: 0.70rem;
}

.button.is-primary:hover, .button.is-primary.is-hovered {
  background-color: #106129 !important;
  border-color: transparent;
  color: #fff;
}

</style>